<template>
    <section class="o-wrapper o-wrapper--center o-page-bottom-spacing">
        <template>
            <page-header>
                <slot slot="title">{{$t('customer.checkout.basket') }}</slot>
                <slot slot="description">
                    {{$t('customer.checkout.instructions')}}
                    <br><br>
                    <p><input @change="$store.dispatch('switchBasket')" name="dropshipment" id="dropshipment" type="checkbox" v-model="basketData.IsDropshipment"/><label for="dropshipment"> {{$t('customer.checkout.dropshipment.text')}}</label></p>
                </slot>
                <slot v-if="basketData.Products && basketData.Products.length" slot="action">
                        <router-link class="c-button--reset u-margin-right u-text-underline-none" :to="{ name: 'ShopOverview' }">
                            <svgicon class="svg-left u-color-alpha-base" name="arrow-rounded" width="5.5" height="5"></svgicon>
                            {{$t('customer.checkout.continue_shopping')}}
                        </router-link>
                        <button :disabled="orderButtonDisabled" @click.prevent="validateBasket" class="c-button c-button--alpha">{{$t('customer.checkout.continue_order')}}</button>
                </slot>
            </page-header>

            <section class="o-wrapper o-wrapper--center">
                <v-banner class="c-banner--commercial o-page-row--large" location="Basket">
                </v-banner>
            </section>

            <v-product v-for="product in basketData.Products" @outOfStock="outOfStock" @inStock="inStock" :productGroup="product" :key="product.ProductId"></v-product>

            <div v-if="basketData.Products && basketData.Products.length" class="u-flex u-flex--content-end u-margin-bottom-medium u-margin-top-medium">
                <div class="u-bgcolor-neutral-x-light u-padding u-font-small">
                    <h4 class="u-text-uppercase u-margin-bottom-small">{{$t('customer.checkout.need_help')}}</h4>
                    <a href="tel:003213670101" class="c-icon-label u-text-underline-none u-color-neutral-dark">
                        <svgicon name="phone"></svgicon>
                        <span>+32(0)13/67.01.01</span>
                    </a>
                    <a href="mailto:info@highdemandbrands.eu" class="c-icon-label u-color-alpha-base">
                        <svgicon name="mail"></svgicon>
                        <span class="u-text-underline">info@highdemandbrands.eu</span>
                    </a>
                </div>
                <div class="c-basket__totals">
                    <div class="u-margin-bottom-small">
                        <span class="c-basket__totals__label">
                            <svg width="31px" height="21px" viewBox="0 0 31 21" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                <g id="Web" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <g id="Winkelmandje" transform="translate(-957.000000, -1190.000000)" stroke="#292929">
                                        <g id="CONTENT" transform="translate(0.000000, 149.000000)">
                                            <g id="Page-1" transform="translate(957.000000, 1042.000000)">
                                                <path d="M19.787234,4.46808511 L24.857234,4.46808511 C25.2791489,4.46808511 25.6742553,4.67680851 25.9123404,5.02531915 L28.0851064,8.93617021 L28.7234043,8.93617021 C29.4414894,8.93617021 30,9.41170213 30,10.3487234 L30,14.6808511 C30,15.3855319 29.4280851,15.9574468 28.7234043,15.9574468 L27.4468085,15.9574468" id="Stroke-1"></path>
                                                <polyline id="Stroke-3" points="8.93617021 0 19.787234 0 19.787234 15.9574468 10.212766 15.9574468"></polyline>
                                                <path d="M5.10638298,15 L1.91489362,15" id="Stroke-5"></path>
                                                <path d="M27.4468085,16.6032128 C27.4468085,18.0106596 26.3010638,19.1506596 24.8878723,19.1506596 C23.4746809,19.1506596 22.3289362,18.0106596 22.3289362,16.6032128 C22.3289362,15.1964043 23.4746809,14.0564043 24.8878723,14.0564043 C26.3010638,14.0564043 27.4468085,15.1964043 27.4468085,16.6032128 Z" id="Stroke-7"></path>
                                                <path d="M10.224,16.6032128 C10.224,18.0106596 9.07825532,19.1506596 7.66506383,19.1506596 C6.25187234,19.1506596 5.10612766,18.0106596 5.10612766,16.6032128 C5.10612766,15.1964043 6.25187234,14.0564043 7.66506383,14.0564043 C9.07825532,14.0564043 10.224,15.1964043 10.224,16.6032128 Z" id="Stroke-9"></path>
                                                <path d="M19.787234,15 L22.3404255,15" id="Stroke-11"></path>
                                                <polyline id="Stroke-13" points="21.0638298 9.57446809 25.5319149 9.57446809 25.5319149 8.93617021 24.2553191 7.0212766"></polyline>
                                                <path d="M0,7 L10.8510638,7" id="Stroke-15"></path>
                                                <path d="M5.10638298,3 L14.6808511,3" id="Stroke-17"></path>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            {{$t('customer.checkout.delivery_cost')}}:
                            <template v-if="this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId] && this.totalPrice < this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts && !this.basketData.IsDropshipment">
                                {{ shipmentCosts }}
                                <br />
                                {{ $t('customer.basket.remaining_for_free_delivery', { remaining: getRemaining() }) }}
                            </template>
                        </span>
                        <span v-if="this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId] && !basketData.IsDropshipment && this.totalPrice >= this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts" class="u-font-small">{{ $t('global.free') }}</span>
                        <span v-else-if="basketData.IsDropshipment">{{ shipmentCosts }}</span>
                    </div>
                    <div>
                        <span class="c-basket__totals__label">{{$t('customer.checkout.total_ex_vat')}}:</span>
                        <span class="u-font-medium u-font-weight-bold">{{ basketTotal | currency(customerCurrencySymbol) }}</span>
                    </div>
                </div>
            </div>

            <div v-if="basketData.Products && basketData.Products.length" class="u-flex u-flex--content-end">
                <button :disabled="orderButtonDisabled" @click.prevent="checkBackOrderProducts" class="c-button c-button--alpha">{{$t('customer.checkout.continue_order')}}</button>
            </div>

            <div v-if="basketData.Products && basketData.Products.length === 0" class="u-font-large u-text-align-center u-padding">
                {{ $t('preorder_fiche.no_products_added') }}<br>
                <span class="u-font-default">{{$t('customer.basket.add_products_via_webshop')}}</span>
            </div>

            <!-- Backorder modal -->
            <v-modal ref="modal">
                <slot slot="title">{{ $t('customer.checkout.products_in_backorder') }}</slot>
                <div class="o-wrapper--center">
                    <form action="" class="c-form c-form--horizontal">
                        <div class="c-form-row">
                            <v-form-row>
                                <p class="u-color-base-dark">
                                    {{ $t('customer.checkout.products_in_backorder_confirmation') }}
                                </p>
                                <div class="c-basket-backorder-product c-basket-backorder-product--column">
                                    <span class="item">{{$t('customer.basket.product.name')}}</span>
                                    <span class="item">{{$t('customer.basket.product.size')}}</span>
                                    <span class="item">{{$t('customer.basket.product.amount')}}</span>
                                    <span class="item">{{$t('customer.checkout.already_in_backorder')}}</span>
                                </div>
                                <div class="c-basket-backorder-product" v-for="product in productsInBackorder">
                                    <span class="item">{{ product.ProductName }}</span>
                                    <span class="item">{{ product.ProductSize }}</span>
                                    <span class="item">{{ product.ProductAmount- product.Stock }}</span>
                                    <span class="item">{{ product.ProductAmountAlreadyInBackorder }}</span>
                                </div>
                            </v-form-row>
                            <v-form-row>
                                <div class="c-form-item">
                                    <button @click.prevent="closeDialog" class="c-button c-button--alpha u-pull-right">{{ $t('global.no') }}</button>
                                    <button @click.prevent="validateBasket" class="c-button c-button--alpha u-pull-right" style="margin-right:10px;">{{ $t('global.yes') }}</button>
                                </div>
                            </v-form-row>
                        </div>
                    </form>
                </div>
            </v-modal>
        </template>
    </section>
</template>

<script>
    import Vue from 'vue'
    import VModal from '@/components/modal/Modal'
    import PageHeader from '@/components/common/PageHeader'
    import VInput from '@/components/form/Input'
    import VProduct from '@/components/basket/Product'
    import VBanner from '@/components/banners/Banner'
    import VFormRow from '@/components/form/Row'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            PageHeader,
            VInput,
            VProduct,
            VBanner,
            VModal,
            VFormRow
        },
        data(){
            return {
                outOfStockProducts: []
            }
        },
        created (){
            this.initialDataFetch()
        },
        computed:{
            ...mapGetters({
                basketData: 'getBasket'
            }),
            totalPrice() {
                let total = 0;

                if(this.basketData){
                    this.basketData.Products.forEach(pg => {
                        pg.Variants.forEach(v => {
                            total += v.ProductTotal;
                        });
                    });
                }

                return total;
            },
            productsInBackorder() {
                if(this.basketData && this.basketData.Products && this.basketData.Products.length){

                    let allVariants = this.basketData.Products.map(x => x.Variants).reduce((a, b) => { return a.concat(b); },[]); // all in one line
                    return allVariants.filter(x => !x.IsPreOrder && x.Stock - x.ProductAmount < 0);
                }

                return [];
            },
            basketTotal() {
                let result = this.totalPrice;
                    if(this.basketData) {
                        if(this.basketData.IsDropshipment
                        && this.basketData.DropshipmentDeliveryAddress
                        && this.basketData.DropshipmentDeliveryAddress.CountryId
                        && this.basketData.DropshipmentDeliveryAddress.CountryId.length > 0
                        && this.totalPrice < this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryDropShipmentCosts)
                        {
                            result += this.basketData.DropshipmentCosts[this.basketData.DropshipmentDeliveryAddress.CountryId];
                        }

                        if(!this.basketData.IsDropshipment
                        && this.basketData.OrderDeliveryAddress
                        && this.basketData.OrderDeliveryAddress.CountryId
                        && this.basketData.OrderDeliveryAddress.CountryId.length > 0
                        && this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId]
                        && this.totalPrice < this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts)
                        {
                            result += this.basketData.ShipmentCosts[this.basketData.OrderDeliveryAddress.CountryId];
                        }
                    }

                return result;
            },
            shipmentCosts() {
                if(this.basketData) {
                    if(this.basketData.IsDropshipment) {
                        if(this.basketData.DropshipmentDeliveryAddress && this.basketData.DropshipmentDeliveryAddress.CountryId && this.basketData.DropshipmentDeliveryAddress.CountryId.length > 0) {
                          if(this.totalPrice >= this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryDropShipmentCosts)
                          {
                            return this.$options.filters.currency(0);
                          } else
                          {
                            return this.$options.filters.currency(this.basketData.DropshipmentCosts[this.basketData.DropshipmentDeliveryAddress.CountryId], this.customerCurrencySymbol);
                          }

                        } else {
                            return this.$t('customer.basket.calculated_in_next_step');
                        }
                    } else {
                        if(this.basketData.OrderDeliveryAddress && this.basketData.OrderDeliveryAddress.CountryId && this.basketData.OrderDeliveryAddress.CountryId.length > 0) {
                          if(this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId] && this.totalPrice >= this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts)
                          {
                            return this.$options.filters.currency(0);
                          } else
                          {
                            return this.$options.filters.currency(this.basketData.ShipmentCosts[this.basketData.OrderDeliveryAddress.CountryId], this.customerCurrencySymbol);
                          }

                        } else {
                            return this.$t('customer.basket.calculated_in_next_step');
                        }
                    }
                }
            },
            orderButtonDisabled(){
                return this.outOfStockProducts.length > 0;
            },
            customerCurrencySymbol() {
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods:{
            initialDataFetch(){
                this.$store.dispatch("getBasket");
            },
            getRemaining(){
              if(this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId] && this.totalPrice >= this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts){
                return this.$options.filters.currency(0, this.customerCurrencySymbol);
              } else
              {
                return this.$options.filters.currency(this.basketData.FreeDeliveryMinimums[this.basketData.OrderDeliveryAddress.CountryId].FreeDeliveryShippingCosts - this.totalPrice, this.customerCurrencySymbol);
              }
            },
            validateBasket(){

                this.$refs.modal.closeDialog(); //close backorder dialog

                this.$store.dispatch("validateBasket").then((result) => {
                    if(result.Errors) {
                        result.Errors.forEach((error) => {
                            this.$notify({
                                group: 'global',
                                title: error,
                                type: 'error',
                                duration: 4000
                            });
                        });
                    } else {
                        this.$router.push({
                            name: 'BasketCheckout',
                        })
                    }
                }).catch((response) => {
                    this.$notify({
                        group: 'global',
                        title: response.statusText,
                        type: 'error',
                        duration: 4000
                    });
                });
            },
            checkBackOrderProducts(){
                if(this.productsInBackorder.length){
                    this.$refs.modal.openDialog();
                }
                else
                {
                    this.validateBasket();
                }
            },
            closeDialog(){
                this.$refs.modal.closeDialog();
            },
            outOfStock(variantId) {
                if(!this.outOfStockProducts.includes(variantId)){
                    this.outOfStockProducts.push(variantId);
                }
                this.updateBasketCount();
            },
            inStock(variantId) {
                if(this.outOfStockProducts.includes(variantId)){
                    this.outOfStockProducts = this.outOfStockProducts.filter(e => e !== variantId);
                }
                this.updateBasketCount();
            },
            updateBasketCount() {
                let count = 0;

                this.basketData.Products.forEach((product) => {
                    product.Variants.forEach((variant) => {
                        count += parseInt(variant.ProductAmount);
                    });
                });

                this.$store.dispatch('updateBasketCount', count);
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-icon-label {
        &:hover {
            color: black !important;
        }
    }
    .c-basket__totals {
        border: 1px solid $color-neutral;
        padding: 30px 60px;
        margin-left: 2em;
        &__label {
            display: inline-block;
            min-width: 180px;
        }
    }

    .c-basket-backorder-product{
        border-top: 1px dotted $color-neutral;
        padding: 0.5em 0;

        .item {
            display:inline-block !important;
            padding: 4px 0;
            width:11%;
            text-align: center;

            &:first-child {
                width: 55%;
                text-align: left;
            }

            &:last-child {
                width: 20%;
            }
        }

        &--column {
            span {
                font-size: em(14px);
                color: darken($color-neutral, 15%);
                padding-bottom: 0.5em;
            }
        }
    }

    .c-basket-backorder-product--column{
        border:none;
    }
</style>



// WEBPACK FOOTER //
// src/views/customer/basket/Overview.vue